import { Text } from '@mxenabled/mxui'

import Stack from '@mui/material/Stack'
import { type SxProps } from '@mui/material/styles'

interface DoubleBarChartLegendMXUIProps {
  comparisonColor: string
  legendLabelComparison?: string
  legendLabelMain?: string
  legendStyle?: SxProps
  mainColor: string
}

export const DoubleBarChartLegendMXUI = ({
  comparisonColor,
  legendLabelComparison,
  legendLabelMain,
  legendStyle = {},
  mainColor,
}: DoubleBarChartLegendMXUIProps) => (
  <Stack
    sx={{
      alignItems: 'center',
      flexDirection: 'row',
      gap: 24,
      justifyContent: 'flex-start',
      pt: 8,
      ...legendStyle,
    }}
  >
    {legendLabelMain && (
      <Stack alignItems="center" flexDirection="row" gap={8}>
        <svg
          aria-hidden="true"
          aria-labelledby="legendMain"
          fill="none"
          height="12"
          role="figure"
          width="12"
        >
          <rect fill={mainColor} height="12" rx="2" width="12" x="0.4375" />
        </svg>
        <Text id="legendMain" sx={{ fontSize: 13, fontWeight: 400 }} variant="caption">
          {legendLabelMain}
        </Text>
      </Stack>
    )}
    {legendLabelComparison && (
      <Stack alignItems="center" flexDirection="row" gap={8}>
        <svg
          aria-hidden="true"
          aria-labelledby="legendComparison"
          fill="none"
          height="12"
          role="figure"
          width="12"
        >
          <rect fill={comparisonColor} height="12" rx="2" width="12" x="0.4375" />
        </svg>
        <Text id="legendComparison" sx={{ fontSize: 13, fontWeight: 400 }} variant="caption">
          {legendLabelComparison}
        </Text>
      </Stack>
    )}
  </Stack>
)
